import ApiAuthorzationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { FetchData } from "./components/FetchData";
import Groceries from "./components/Groceries";
import GroceryHistory from "./components/GroceryHistory";
import GroceryHistoryByItem from "./components/GroceryHistoryByItem";
import FinancesUploadInvestments from "./components/FinancesUploadInvestments";
import FinancesSummary from "./components/FinancesSummary";
import FinancesByAccount from "./components/FinancesByAccount";
import FinancesSales from "./components/FinancesSales";
import FinancesWithdrawals from "./components/FinancesWithdrawals";
import FinancesStaking from "./components/FinancesStaking";
import FinancesTagged from "./components/FinancesTagged";
import FinancesMatchWithdrawals from "./components/FinancesMatchWithdrawals";
import FinancesMatchDeposits from "./components/FinancesMatchDeposits";
import FinancesSettings from "./components/FinancesSettings";
import FinancesUploadExpenses from "./components/FinancesUploadExpenses";
import FinancesExpenses from "./components/FinancesExpenses";
import DumpList from './components/DumpList';
import { Home } from "./components/Home";
import FinancesInvestmentCompare from "./components/FinancesInvestmentCompare";
import NotAuthorized from "./components/NotAuthorized";
import WorkHistory from './components/WorkHistory';
import CurrentPayPeriod from './components/CurrentPayPeriod';
import Payroll from './components/Payroll';
import AlexaTest from './components/AlexaTest';

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/work/workhistory',
    requireAuth: true,
    requiredClaim: { type: "ViewWork", value: "true" },
    element: <WorkHistory />
  },
  {
    path: '/work/currentpayperiod',
    requireAuth: true,
    requiredClaim: { type: "ViewWork", value: "true" },
    element: <CurrentPayPeriod />
  },
  {
    path: '/work/payroll',
    requireAuth: true,
    requiredClaim: { type: "ViewWork", value: "true" },
    element: <Payroll />
  },
  {
    path: '/fetch-data',
    requireAuth: true,
    element: <FetchData />
  },
  {
    path: '/groceries',
    requireAuth: true,
    requiredClaim: { type: "ViewGroceries", value: "true" },
    element: <Groceries />
  },
  {
    path: '/groceries/groceryhistory',
    requireAuth: true,
    requiredClaim: { type: "ViewGroceries", value: "true" },
    element: <GroceryHistory />
  },
  {
    path: '/groceries/groceryhistorybyitem',
    requireAuth: true,
    requiredClaim: { type: "ViewGroceries", value: "true" },
    element: <GroceryHistoryByItem />
  },
  {
    path: '/finances/uploadinvestments',
    requireAuth: true,
    requiredClaim: { type: "ViewFinancialDetails", value: "true" },
    element: <FinancesUploadInvestments />
  },
  {
    path: '/finances/summary',
    requireAuth: true,
    requiredClaim: { type: "ViewFinancialDetails", value: "true" },
    element: <FinancesSummary />
  },
  {
    path: '/finances/accounts',
    requireAuth: true,
    requiredClaim: { type: "ViewFinancialBasic", value: "true" },
    element: <FinancesByAccount />
  },
  {
    path: '/finances/sales',
    requireAuth: true,
    requiredClaim: { type: "ViewFinancialDetails", value: "true" },
    element: <FinancesSales />
  },
  {
    path: '/finances/withdrawals',
    requireAuth: true,
    requiredClaim: { type: "ViewFinancialDetails", value: "true" },
    element: <FinancesWithdrawals />
  },
  {
    path: '/finances/staking',
    requireAuth: true,
    requiredClaim: { type: "ViewFinancialDetails", value: "true" },
    element: <FinancesStaking />
  },
  {
    path: '/finances/tagged',
    requireAuth: true,
    requiredClaim: { type: "ViewFinancialDetails", value: "true" },
    element: <FinancesTagged />
  },
  {
    path: '/finances/matchwithdrawals',
    requireAuth: true,
    requiredClaim: { type: "ViewFinancialDetails", value: "true" },
    element: <FinancesMatchWithdrawals />
  },
  {
    path: '/finances/matchdeposits',
    requireAuth: true,
    requiredClaim: { type: "ViewFinancialDetails", value: "true" },
    element: <FinancesMatchDeposits />
  },
  {
    path: '/finances/compare',
    requireAuth: true,
    requiredClaim: { type: "ViewFinancialDetails", value: "true" },
    element: <FinancesInvestmentCompare />
  },
  {
    path: '/finances/settings',
    requireAuth: true,
    requiredClaim: { type: "ViewFinancialDetails", value: "true" },
    element: <FinancesSettings />
  },
  {
    path: '/finances/uploadexpenses',
    requireAuth: true,
    requiredClaim: { type: "ViewExpenses", value: "true" },
    element: <FinancesUploadExpenses />,
  },
  {
    path: '/finances/expenses',
    requireAuth: true,
    requiredClaim: { type: "ViewExpenses", value: "true" },
    element: <FinancesExpenses />,
  },
  {
    path: '/todo/dump',
    requireAuth: true,
    requiredClaim: { type: "ViewTodo", value: "true" },
    element: <DumpList />
  },
  {
    path: '/alexatest',
    requireAuth: true,
    requiredClaim: { type: "ViewAlexaTest", value: "true" },
    element: <AlexaTest />
  },
  {
    path: '/not-authorized',
    element: <NotAuthorized />
  },
  ...ApiAuthorzationRoutes
];

export default AppRoutes;
